import type { KnowledgeDocumentListParams } from "../types";

export const knowledgeQueryKeys = {
  all: ["captain-knowledge"] as const,
  list: (params?: KnowledgeDocumentListParams) =>
    [...knowledgeQueryKeys.all, "list", params ?? {}] as const,
  metrics: () => [...knowledgeQueryKeys.all, "metrics"] as const,
  detail: (fileName: string) =>
    [...knowledgeQueryKeys.all, "detail", fileName] as const,
};
